module.exports = __webpack_public_path__ + "static/media/EQM.f5098165.png";